import { useDeferredValue, useEffect } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Defers a view value so toggles feel instant, and syncs transitioning
 * state to Redux so RoadmapHeader shows "Refreshing..." until the deferred
 * value catches up (mirrors quarterly Roadmap.tsx Must Wins pattern).
 */
export function useDeferredViewTransition<T>(
  active: T,
  setTransitioning: (transitioning: boolean) => {
    type: string;
    payload: boolean;
  }
) {
  const displayed = useDeferredValue(active);
  const dispatch = useDispatch();

  useEffect(() => {
    const transitioning = active !== displayed;
    dispatch(setTransitioning(transitioning));
    return () => {
      dispatch(setTransitioning(false));
    };
  }, [active, displayed, dispatch, setTransitioning]);

  return { active, displayed };
}
